import { DTLogger } from 'dt-core';

const DEBUG_KEY = 'dtinmobi';
const DEBUG_PRE = 'DTInMobi:';

(() => {
	const waitConsentReady = () => {
		const interval = 250; // 250ms
		const timeout = 60000; // 1 minute
		let elapsedTime = 0;

		const checkConsent = setInterval(() => {
			if (typeof __gpp === 'function') { // eslint-disable-line no-underscore-dangle
				clearInterval(checkConsent);

				__gpp('addEventListener', (gppData, success) => {
					DTLogger.debug(DEBUG_KEY, `${DEBUG_PRE} gpp responded:`, { gppData, success });

					const {
						pingData: data = {},
					} = gppData || {};

					const {
						cmpStatus = 'unknown',
						signalStatus = 'unknown',
					} = data || {};

					if (cmpStatus === 'loaded' && signalStatus === 'ready' && typeof window.consentReady === 'function') {
						window.consentReady(data);
					}
				});
			} else {
				elapsedTime += interval;
				if (elapsedTime >= timeout) {
					clearInterval(checkConsent);
					DTLogger.debug(DEBUG_KEY, `${DEBUG_PRE} Consent check timed out`);
				}
			}
		}, interval);
	};

	DTLogger.debug(DEBUG_KEY, `${DEBUG_PRE} Waiting for consent status`);

	waitConsentReady();
})();
